import { Box, Container, Stack } from '@mui/material'
import React, { memo } from 'react'
import { m } from 'framer-motion'
import { NavLink } from 'react-router-dom'

import { MotionViewport, varFade } from 'src/components/shared/animate'
import Text from '../shared/text/Text'
import Button from '../shared/button/Button'
import { SIGNUP_URL } from '../../constants/navigation'
import brandConfig from 'brandConfig'
import { Label } from '../shared/label'
import MembershipDataTable from '../membership/MembershipDataTable'

const MembershipLevels = ({ t, tiers }) => {
  const { name } = brandConfig
  return (
    <Stack>
      <Box
        component='section'
        // sx={{ overflow: 'hidden', position: 'relative' }}
      >
        <MotionViewport>
          <Container sx={{ textAlign: 'center', py: { xs: 6, md: 15 } }}>
            <Label color='primary' sx={{ textTransform: 'uppercase' }}>
              {t('welcome.membership-levels')}
            </Label>
            <Text
              component={m.h2}
              variants={varFade('inLeft')}
              variant='h2'
              sx={{ my: 3, lineHeight: 1.1 }}
              label={t('welcome.stake-and-level-up')}
            />
            <Text
              component={m.p}
              variants={varFade('inLeft')}
              sx={[
                (theme) => ({
                  color: 'text.secondary',
                  ...theme.applyStyles('dark', {
                    color: 'common.white'
                  })
                })
              ]}
              label={t('welcome.stake-and-level-up-desc', { name })}
            />
            <Stack spacing={10} sx={{ my: 5 }}>
              <MembershipDataTable tiers={tiers} t={t} />
              <NavLink to={SIGNUP_URL}>
                <Button
                  component={m.button}
                  variants={varFade('inRight')}
                  color='primary'
                  label={t('welcome.sign-up-free-today')}
                />
              </NavLink>
            </Stack>
          </Container>
        </MotionViewport>
      </Box>
      <Box component='section' sx={[{ bgcolor: 'background.neutral' }]}>
        <MotionViewport>
          <Container
            component={MotionViewport}
            sx={{ textAlign: 'center', py: { xs: 6, md: 15 } }}
          >
            <Label color='primary' sx={{ textTransform: 'uppercase' }}>
              {t('welcome.getting-started')}
            </Label>
            <Text
              component={m.h2}
              variants={varFade('inRight')}
              variant='h2'
              sx={{ my: 3, mb: { xs: 3, md: 6 }, lineHeight: 1.1 }}
              label={t('welcome.join-today', { name })}
            />
            <NavLink to={SIGNUP_URL}>
              <Button
                component={m.button}
                variants={varFade('inRight')}
                color='primary'
                label={t('welcome.sign-up-here')}
                sx={{ textTransform: 'uppercase' }}
              />
            </NavLink>
          </Container>
        </MotionViewport>
      </Box>
    </Stack>
  )
}

export default memo(MembershipLevels)
